// src/components/DashBoard/ChamadosPorUsuario.jsx
import React, { useState, useEffect } from "react";
import Select from "../ui/Select";
import { User } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

export default function ChamadosPorUsuario() {
  const [periodo, setPeriodo] = useState("total");
  const [usuario, setUsuario] = useState("todos");

  // 🔹 Agora o padrão inicial é sempre "finalizado"
  const [status, setStatus] = useState("finalizado");

  const [dados, setDados] = useState([]);
  const [usuarios, setUsuarios] = useState([{ value: "todos", label: "Todos Usuários" }]);

  // 🔹 Buscar dados da API quando filtros mudam
  useEffect(() => {
    const fetchDados = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/Dashboard/usuarios.php?periodo=${periodo}&usuario=${usuario}&status=${status}`
        );
        const data = await response.json();

        if (data.success) {
          setDados(data.dados);

          // Atualiza lista de usuários com base nos técnicos do backend
          const listaUsuarios = [
            { value: "todos", label: "Todos Usuários" },
            ...data.dados.map((item) => ({
              value: item.usuario,
              label: item.usuario,
            })),
          ];
          setUsuarios(listaUsuarios);
        }
      } catch (error) {
        console.error("Erro ao carregar chamados por usuário:", error);
      }
    };

    fetchDados();
  }, [periodo, usuario, status]);

  const opcoesPeriodo = [
    { value: "total", label: "Total" },
    { value: "7d", label: "Últimos 7 dias" },
    { value: "15d", label: "Últimos 15 dias" },
    { value: "30d", label: "Últimos 30 dias" },
    { value: "60d", label: "Últimos 60 dias" },
    { value: "ano", label: "Ano Atual" },
  ];

  const opcoesStatus = [
    { value: "todos", label: "Todos Status" },
    { value: "aberto", label: "Aberto" },
    { value: "pendente", label: "Pendente" },
    { value: "andamento", label: "Em Andamento" },
    { value: "finalizado", label: "Finalizado" },
  ];

  // 🔹 Definir cor do total de acordo com o status
  const getCorStatus = (status) => {
    switch (status) {
      case "finalizado":
        return "text-green-600";
      case "pendente":
        return "text-red-600";
      case "aberto":
        return "text-yellow-600";
      case "andamento":
        return "text-blue-600";
      default:
        return "text-gray-900";
    }
  };

  return (
    <div className="bg-white rounded-sm shadow-lg shadow-black/30 border border-gray-300 p-4">
      {/* Cabeçalho */}
      <div className="flex items-center justify-between mb-4 gap-4">
        <h3
          className="font-bold"
          style={{
            fontFamily: '"Source Sans Pro", sans-serif',
            fontSize: "14px",
            color: "#777777",
          }}
        >
          Total de Chamados por Usuário
        </h3>

        <div className="flex gap-3">
          <div className="w-40">
            <Select value={periodo} onChange={setPeriodo} options={opcoesPeriodo} />
          </div>
          <div className="w-44">
            <Select value={usuario} onChange={setUsuario} options={usuarios} />
          </div>
          <div className="w-44">
            {/* 🔹 Já inicia em "finalizado", mas pode mudar */}
            <Select value={status} onChange={setStatus} options={opcoesStatus} />
          </div>
        </div>
      </div>

      {/* Lista com ícone + animação */}
      <motion.ul
        className="divide-y divide-gray-200"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        <AnimatePresence>
          {dados.map((item, index) => (
            <motion.li
              key={`${item.usuario}-${index}`}
              className={`flex justify-between items-center py-3 px-4 text-sm transition-colors
                ${index % 2 === 0 ? "bg-gray-50" : "bg-white"} 
                hover:bg-gray-100`}
              style={{ fontFamily: "Inter, sans-serif" }}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.25 }}
            >
              <div className="flex items-center gap-3">
                <User size={20} className="text-gray-600" />
                <span className="text-gray-700 font-medium">{item.usuario}</span>
              </div>
              <span
                className={`font-bold ${getCorStatus(item.status)}`}
                style={{ fontFamily: "Inter, sans-serif", fontSize: "24px" }}
              >
                {item.total}
              </span>
            </motion.li>
          ))}
        </AnimatePresence>
      </motion.ul>
    </div>
  );
}
